/**
 * Is someone using this tab? Staff stay signed in until 24 hours without activity
 * (backend lib/staff/session-idle.ts). Calls the admin makes on its own while nobody has touched
 * the page for IDLE_AFTER_MS (the bell, System status refreshing) are marked `x-keel-idle: 1`, so
 * they don't keep an unattended computer signed in forever. lib/observability.ts adds the header.
 */
export const IDLE_HEADER = "x-keel-idle"
export const IDLE_AFTER_MS = 5 * 60_000

let lastActive = Date.now()
let installed = false

export function markActive(now = Date.now()) {
  lastActive = now
}

export function isIdle(now = Date.now()): boolean {
  return now - lastActive > IDLE_AFTER_MS
}

/** Clicks, typing, scrolling, touch, and coming back to the tab count as use. */
export function installActivityTracking() {
  if (installed || typeof window === "undefined") return
  installed = true
  const opts = { capture: true, passive: true } as const
  for (const ev of ["pointerdown", "keydown", "wheel", "touchstart"]) window.addEventListener(ev, () => markActive(), opts)
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") markActive()
  })
}
